<template>
  <div
    :class="[sizesMap[props.size], border ? 'border' : '']"
    :style="style"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>

import { computed, CSSProperties } from 'vue';
import { Colors } from '@/store/theme.store';
import { useTheme } from '@/composable/ui/useTheme';

const props = defineProps({
  size: {
    type: String as() => 'sm' | 'md' | 'sm-md' | 'lg' | 'xs' | 'small-xs',
    default: 'md',
  },
  justify: {
    type: String as () => 'start' | 'center' | 'end',
    default: 'start',
  },
  color: {type: String as () => keyof Colors, default: 'title'},
  border: Boolean,
  bold: Boolean,
});

const theme = useTheme();

const sizesMap = {
  'small-xs': 'small-xs',
  xs: 'title-xs',
  sm: 'title-sm',
  'sm-md': 'title-sm-md',
  md: 'title-md',
  lg: 'title-lg',
};

const textAligns = {
  start: 'left',
  center: 'center',
  end: 'right',
};

const style = computed(() => ({
  color: theme.resolveColor(props.color),
  fontWeight: props.bold ? 700 : 400,
  textAlign: textAligns[props.justify] as CSSProperties['textAlign'],
}));

</script>

<style scoped>
div {
  font-weight: 500;
  letter-spacing: 1px;
  text-align: left;
  background-color: transparent;
}

.border {
  border: var(--white) solid 1px;
  border-radius: 20px;
  padding-left: 5px;
  padding-right: 5px;
}
</style>
